"use strict";module.exports=Math.sign||function(t){return 0==(t=+t)||t!=t?t:t<0?-1:1};